// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/search/search.actions.go

export const SEARCH = "mondoo.index.SearchService.Search";
